// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__LA2I8","header":"ClearentDisclaimer_header__8qMp8","inner":"ClearentDisclaimer_inner__35DWA"};